// ------------------------------------
// props 輸入需求 :
// props.page_active : function
//      setAlertCancel({
//          cancel: !alertCancel.cancel,
//          resident:res
//      })
//      setNotify(false)
// props.closeTab : function                            關掉此component
// ------------------------------------

import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Account from '../../actions/Account';
import dataHandler_alert from '../../actions/dataHandler_alert';
import { LogTime } from '../../actions/forFrontEnd_Log';
import comm_imgs from '../../comm_imgs';
import { HR, RR } from '../residents/historyRecord/HISVital/SVGRRHR';
import ConfigHandler from '../../actions/ConfigHandler';

const NotificationBar = (props) => {

    const store_res_array = useSelector(state => state.store_residents.orign_residents_array)
    const { t } = useTranslation()
    const store_alert = useSelector(state => state.store_alerts.alert_array)
    function calculateReleventTime(_time = "") {
        let _now_time = new Date().getTime()
        let _timestamp = new Date(_time).getTime()
        let _relevent_time = parseInt((_now_time - _timestamp) / 1000)
        if (_relevent_time < 60) { return `${_relevent_time}` + t('GLOBAL.UNIT.SECONDS_AGO') }
        else {
            _relevent_time = parseInt(_relevent_time / 60)
            if (_relevent_time < 60) { return `${_relevent_time}` + t('GLOBAL.UNIT.MINUTES') }
            else { return new LogTime(new Date(_time)).getTime_withoutMillsec() }
        }
    }
    function abbreviate(str, length) {
        if (str.length > length) {
            return <div className='abbri' title={str}>{str.substring(0, 5)}</div>
        }
        else { return <div>{str}</div> }
    }
    function diaperControl(ab_type) {
        // need_to_wash": 1, "angle_abnormal": 1, "water_not_enough": 0, "sewage_volume": 0, "poop_bowl_abnormal"
        if (ab_type === "angle_abnormal") return t("DIAPER.ANGLE_ABNORMAL")
        else if (ab_type === "sewage_volume") return t("DIAPER.SEWAGE_VOLUME")
        else if (ab_type === "poop_bowl_abnormal") return t("DIAPER.POOP_BOWL_ABNORMAL")
        else if (ab_type === "water_not_enough") return t("DIAPER.WATER_NOT_ENOUGH")
    }
    let _div = store_alert.map((res, index) => {
        if (ConfigHandler.isFdaClass === 2) return
        let resident = store_res_array.filter(store => store.id === res.resident_id)[0];
        if (resident === undefined) return
        if (res.type !== undefined) {
            return (
                <div className='notf_row w-100 border fx-d-r fx-cspar' key={index} onClick={() => {
                    props.toggleAlertCancel(resident)
                }}>
                    <div className='h-100 w-20 fx-ccc outer'>
                        {
                            res.type === "rr" ? <RR type={"icon_pic"} /> : <HR type={"icon_pic"} />
                        }
                    </div>
                    <div className='w-80 fx-d-r fx-cspar'>
                        <div className='fx-d-c'>
                            <div>{abbreviate(String(resident.first_name), 5)}</div>
                            <div>{abbreviate(String(resident.last_name), 5)}</div>
                        </div>
                        <div className='fx-d-c'>
                            {
                                res.type === "rr" ?
                                    res.abnormal === "low" ? t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_LOW') : t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_HIGH')
                                    :
                                    res.abnormal === "low" ? t('RESIDENTS_SETTING.SENSOR.HEART_LOW') : t('RESIDENTS_SETTING.SENSOR.HEART_HIGH')
                            }
                        </div>
                        <div>{calculateReleventTime(res.created_at, '')}</div>
                    </div>
                </div>
            )
        }
        else if (res.bedState !== undefined) {
            let _dh_alert = dataHandler_alert(res.bedStateAlertLevel, res.bedState)
            return <div className='notf_row w-100 border fx-d-r fx-cspar' key={index} onClick={() => {
                props.toggleAlertCancel(resident)
            }}>
                <div className='h-100 w-20 fx-ccc'><img src={_dh_alert.img} className='h-60' alt="leave" /></div>
                <div className='w-80 fx-d-r fx-cspar'>
                    <div className='fx-d-c'>
                        <div>{abbreviate(String(resident.first_name), 5)}</div>
                        <div>{abbreviate(String(resident.last_name), 5)}</div>
                    </div>
                    <div>{t(_dh_alert.msg)}</div>
                    <div>{calculateReleventTime(res.timestamp)}</div>
                </div>
            </div>
        }
        else if (res.abnormal_type !== undefined) {
            return <div className='notf_row w-100 border fx-d-r fx-cspar' key={index}>
                <div className='h-100 w-20 fx-ccc'><img src={comm_imgs.DIAPER_THROUGHT} className='h-60' alt="leave" /></div>
                <div className='w-80 fx-d-r fx-cspar'>
                    <div className='fx-d-c'>
                        <div>{abbreviate(String(resident.first_name), 5)}</div>
                        <div>{abbreviate(String(resident.last_name), 5)}</div>
                    </div>
                    <div className='fx-ccc'>{diaperControl(res.abnormal_type)}</div>
                    <div>{calculateReleventTime(res.created_at)}</div>
                </div>
            </div>
        }
    })
    let _divFinal = _div.filter(res => res !== undefined)
    if (Account.isMobileOrTablet()) {
        return (
            <div className='notf_popup mobile border ovy-a' onClick={e => e.stopPropagation()}>
                {(_divFinal.length === 0) ?
                    <div className='notf_row w-100 border fx-d-r fx-cspar'>{'---' + t('GLOBAL.NO_NOTIFICATION') + '---'}</div>
                    : _divFinal
                }
            </div>
        );
    }
    else {
        return (
            <div className='pos-f z-1 wid-full hig-full top-0 left-0' onClick={() => { props.closeTab() }}>
                <div className='w-20 notf_popup mar-notf web pos-a z-5 border ovy-a' onClick={e => e.stopPropagation()}>
                    {(_divFinal.length === 0) ?
                        <div className='notf_row w-100 border fx-d-r fx-cspar'>{'---' + t('GLOBAL.NO_NOTIFICATION') + '---'}</div>
                        : _divFinal
                    }
                </div>
            </div>
        );
    }
}
export default NotificationBar;
